<template>
  <div>
    <div class="chat-search element-wrapper">
      <div class="element-actions">
        <form class="form-inline justify-content-sm-end">
          <label class="smaller" for="">Session Filter</label>
          <select class="form-control form-control-sm form-control-faded" v-model="selected" v-on:change="onChange">
            <option v-for="option, index in filter_options" :value="option.key" @change="filterImages(option.key)" :selected="selected == option.name">{{option.value}}</option>
            <option value="all_session">All Sessions</option>
          </select>
        </form>
      </div>
      <h6 class="element-header">Images</h6>
    </div>
    <div class="user-list">
      <div class="user-w">
        <div class="avatar with-status status-green">
          <input type="hidden" class="id_image" value="1">
          <clazy-load src="http://placehold.jp/15/3d4070/ffffff/150x150.png?text=Placeholder%20Image%0ATo%20be%20replaced" class="drag-drop incoming-image">
            <input type="hidden" class="id_image" value="1">
            <img src="http://placehold.jp/15/3d4070/ffffff/150x150.png?text=Placeholder%20Image%0ATo%20be%20replaced">
            <div class="preloader" slot="placeholder">
              Loading image
            </div>
          </clazy-load>
        </div>
        <div class="user-info">
          <div class="user-name">
            Placeholder Image
            <br> Placeholder

          </div>
          <div class="last-message">
            <div class="chat-extra-actions">
            </div>
          </div>
        </div>
      </div>

<!-- fanatics only -->
      <div v-if="clientDetails.name == 'Fanatics'">
        <div class="user-w">
          <div class="avatar with-status status-green">
            <input type="hidden" class="id_image" value="2">
            <clazy-load src="https://placehold.jp/d9d9d9/000000/150x150.png?text=Inhouse" class="drag-drop incoming-image">
              <input type="hidden" class="id_image" value="2">
              <img src="https://placehold.jp/d9d9d9/000000/150x150.png?text=Inhouse">
              <div class="preloader" slot="placeholder">
                Loading image
              </div>
            </clazy-load>
          </div>
          <div class="user-info">
            <div class="user-name">
              Inhouse
              <br> Placeholder

            </div>
            <div class="last-message">
              <div class="chat-extra-actions">
              </div>
            </div>
          </div>
        </div>
        <div class="user-w">
          <div class="avatar with-status status-green">
            <input type="hidden" class="id_image" value="3">
            <clazy-load src="https://placehold.jp/20/fbe86a/000000/150x150.png?text=Logo%20Replacement" class="drag-drop incoming-image">
              <input type="hidden" class="id_image" value="3">
              <img src="https://placehold.jp/20/fbe86a/000000/150x150.png?text=Logo%20Replacement">
              <div class="preloader" slot="placeholder">
                Loading image
              </div>
            </clazy-load>
          </div>
          <div class="user-info">
            <div class="user-name">
              Logo replacement
              <br> Placeholder

            </div>
            <div class="last-message">
              <div class="chat-extra-actions">
              </div>
            </div>
          </div>
        </div>
        <div class="user-w">
          <div class="avatar with-status status-green">
            <input type="hidden" class="id_image" value="4">
            <clazy-load src="https://placehold.jp/20/82fb6a/000000/150x150.png?text=Logo%20replacement%20%26%20color%20match" class="drag-drop incoming-image">
              <input type="hidden" class="id_image" value="4">
              <img src="https://placehold.jp/20/82fb6a/000000/150x150.png?text=Logo%20replacement%20%26%20color%20match">
              <div class="preloader" slot="placeholder">
                Loading image
              </div>
            </clazy-load>
          </div>
          <div class="user-info">
            <div class="user-name">
              Logo replacement & color match
              <br> Placeholder

            </div>
            <div class="last-message">
              <div class="chat-extra-actions">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="user-w" v-if="images_filtered && image && !image.id_product_image" v-for="image, index in filtered_images">
        <div class="avatar with-status status-green">
          <input type="hidden" class="id_image" :value="image.id_image">
          <clazy-load :src="getImage(image)" class="drag-drop incoming-image">
            <input type="hidden" class="id_image" :value="image.id_image">
            <img :src="getImage(image)">
            <div class="preloader" slot="placeholder">
              Loading image
            </div>
          </clazy-load>
        </div>
        <div class="user-info">
          <div class="user-date">
            <i class="icon-trash " @click="markDelete(image)"></i> <br />
          </div>
          <div class="user-name">
            {{'Shot by ' + (image.name)}}
            <br> Session {{image.id_photodesk_session}}

          </div>
          <div class="last-message">
            <div class="chat-extra-actions">
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
.qc-passed {
  color: #75da62 !important;
}

.qc-failed {
  color: #ed1c24 !important;
}
</style>

<script>
import EmptyState from '@/components/common/EmptyState'
import DnD from '@/mixins/dragdrop.js'

export default {
  props: ['images', 'currentSession', 'finalImages'],
  components: {
    EmptyState
  },
  mixins: [DnD],
  data: function () {
    return {
      filter_options: [{ value: 'This Session', key: this.currentSession }],
      filtered_images: [],
      selected: 'This Session',
      images_filtered: false
    }
  },
  mounted () {
    this.getFilterOptions()
    this.DnD()
  },
  computed: {
    clientDetails () {
	    return this.$store.getters.clientDetails
    }
  },
  methods: {
    getFilterOptions: function () {
      var self = this
      self.images &&
        self.images.forEach(function (image) {
          if (image.id_photodesk_session != self.currentSession) {
            let obj = self.filter_options.find(
              o => o.key === image.id_photodesk_session
            )
            if (obj == null || obj == '' || obj == undefined) {
              self.filter_options.push({
                value: 'Session ' + image.id_photodesk_session,
                key: image.id_photodesk_session
              })
            }
          }
        })
      this.filterImages(self.currentSession)
    },
    filterImages: function (filterBy) {
      var self = this
      self.images_filtered = false
      self.filtered_images = []

      if (filterBy == 'all_session') {
        self.filtered_images = self.images
        self.images_filtered = true
        return true
      }

      self.images.forEach(function (image) {
        if (image.id_photodesk_session == filterBy) {
          self.filtered_images.push(image)
        }
      })
      self.images_filtered = true
    },
    onChange: function () {
      var self = this
      this.filterImages(self.selected)
    },
    getImage: function (image) {
      if (image) {
        return image.host + image.raw_thumb_location
      } else {
        return 'https://storage.googleapis.com/sb-prod-assets/Defaults/noimage.png'
      }
    },
    markDelete: function (image) {
      if (confirm('Are you sure you want to delete this image?')) {
        this.deleteImage(image)
      }
    },
    deleteImage: function (image) {
      var self = this
      const url = '/imagedesk/image/delete'

      let data = {
        id_image: image.id_image
      }
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$emit('deleteInterface')
          self.$store.dispatch('updateToast', {
            text: 'Image deleted',
            show: true
          })
        })
        .catch(function (error) {
          self.loadingRail = false
          self.$store.dispatch('updateToast', {
            text: error.response.data.error || 'Something went wrong',
            show: true
          })
        })
    }
  },
  watch: {
    images: function (newVal, oldVal) {
      // watch it
      this.getFilterOptions()
    }
  }
}
</script>

<style scoped>
.hide {
  display: none !important;
}
</style>
